import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import LegalLayout from "../components/legal/LegalLayout";
import { tenantLegalApi } from "../lib/api";

export default function TenantSmsTerms() {
  const { slug } = useParams();
  const [info, setInfo] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    tenantLegalApi
      .info(slug)
      .then((d) => active && setInfo(d))
      .catch(() => active && setNotFound(true));
    return () => {
      active = false;
    };
  }, [slug]);

  if (notFound) {
    return (
      <div className="min-h-screen bg-[#0B1220] text-slate-300 flex items-center justify-center" data-testid="tenant-legal-not-found">
        <p>This page could not be found.</p>
      </div>
    );
  }
  if (!info) {
    return (
      <div className="min-h-screen bg-[#0B1220] flex items-center justify-center">
        <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
      </div>
    );
  }

  const name = info.businessName;
  return (
    <LegalLayout title={`${name} SMS Terms & Conditions`} updated="August 2026">
      <section data-testid="tenant-sms-terms-content">
        <p>
          By providing your mobile phone number to <strong>{name}</strong> and opting in, you agree to receive text messages (SMS)
          from {name} related to your appointments and services, including appointment confirmations, reminders, rescheduling
          notices, and technician arrival/service-status updates.
        </p>
      </section>
      <section>
        <h2>1. Message Frequency</h2>
        <p>Message frequency varies depending on your scheduled appointments and services.</p>
      </section>
      <section>
        <h2>2. Message and Data Rates</h2>
        <p>Message and data rates may apply. Check with your mobile carrier for details on your plan.</p>
      </section>
      <section>
        <h2>3. Opt-Out</h2>
        <p>
          You can cancel this SMS service at any time. Reply <strong>STOP</strong> to any text message to opt out. After you send
          STOP, we will send a one-time confirmation message, and you will no longer receive messages from us. If you want to rejoin,
          reply <strong>START</strong>.
        </p>
      </section>
      <section>
        <h2>4. Help</h2>
        <p>
          Reply <strong>HELP</strong> to any message for assistance
          {info.supportEmail ? (
            <>
              {" "}
              or contact us at <a href={`mailto:${info.supportEmail}`}>{info.supportEmail}</a>
            </>
          ) : null}
          {info.supportPhone ? (
            <>
              {" "}
              / <a href={`tel:${info.supportPhone}`}>{info.supportPhone}</a>
            </>
          ) : null}
          .
        </p>
      </section>
      <section>
        <h2>5. Consent Is Not a Condition of Purchase</h2>
        <p>Consent to receive text messages is not a condition of purchasing any goods or services from {name}.</p>
      </section>
      <section>
        <h2>6. Carriers</h2>
        <p>Carriers are not liable for delayed or undelivered messages.</p>
      </section>
    </LegalLayout>
  );
}
